import React, { Component } from "react";
import { PageContentBanner } from "../Shared/Page/Page";
import "./CraigsLibraryPageContentBanner.scss";
import DateRangeInput from "./DateRangeInput";
import { withCraigsDocsFilters } from "./withCraigsDocs";
import TickerListSearchField from "../../components/Input/TickerListSearchField";
import LoadingIcon from "../../components/LoadingIcon";
import { withRemote } from "../../Utils/Utils";

/**
 * Search options are the distinct Coverage values in this company's library
 * (/documents/tickers), the same column /documents/list filters on. Fetched
 * fresh on every mount (not the session cache) so a publish made earlier in
 * the session shows up as soon as the Library is reopened.
 */
class CraigsLibraryPageContentBanner extends Component {
	state = { coverageOptions: null };

	componentDidMount() {
		this.mounted = true;
		this.props.remote.get("/documents/tickers")
			.then((tickers) => (tickers || []).map((t) => ({ value: t, label: t })))
			.catch((e) => {
				console.warn("Library search options unavailable", e);
				return [];
			})
			.then((coverageOptions) => {
				if (this.mounted) {
					this.setState({ coverageOptions });
				}
			});
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		const { craigsDocsFilters, setCraigsDocsFilters } = this.props;
		const { coverageOptions } = this.state;
		const { ticker, from, to } = craigsDocsFilters;
		return (
			<PageContentBanner divider gap="m">
				{coverageOptions === null ? (
					<LoadingIcon size={32} />
				) : (
					<TickerListSearchField
						minWidth
						size="small"
						placeholder="Search"
						value={ticker}
						tickerListOverwrite={coverageOptions}
						onChange={(ticker) => setCraigsDocsFilters({ ...craigsDocsFilters, ticker })}
						isClearable
						onClear={() => setCraigsDocsFilters({...craigsDocsFilters, ticker: null})}
					/>
				)}
				<DateRangeInput value={{ from, to }} onChange={({ from, to }) => setCraigsDocsFilters({ ...craigsDocsFilters, from, to })} />
			</PageContentBanner>
		);
	}
}

export default withRemote(withCraigsDocsFilters(CraigsLibraryPageContentBanner));
